module.exports = "../images/hero-logo@2x.png?v=65f90e2";